function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 257.7,
  y1: 168.24,
  x2: 227.19,
  y2: 127.87,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 192.43,
  y1: 268.88,
  x2: 170.74,
  y2: 186.89,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 178.53,
  y1: 244.16,
  x2: 180.56,
  y2: 246.59,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 110.27,
  y1: 266.61,
  x2: 109.34,
  y2: 196.05,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 121.56,
  y1: 190.76,
  x2: 123.1,
  y2: 250.23,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 70.82,
  y1: 251.76,
  x2: 111.8,
  y2: 291.2,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: 120.39,
  y1: 247.93,
  x2: 92.25,
  y2: 289.84,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: 97.7,
  y1: 242.26,
  x2: 108.59,
  y2: 307.18,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: 245.62,
  y1: 221.39,
  x2: 291.02,
  y2: 221.39,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: 299.23,
  y1: 133.88,
  x2: 246.22,
  y2: 142.91,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: 268.38,
  y1: 159.54,
  x2: 214.56,
  y2: 161.6,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: 297.23,
  y1: 159.59,
  x2: 233.13,
  y2: 125.69,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: 248.03,
  y1: 64.7,
  x2: 258.74,
  y2: 91.35,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: 247.89,
  y1: 44.78,
  x2: 242.34,
  y2: 75.44,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 250.33,
  y1: 45.82,
  x2: 245.23,
  y2: 74.02,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Construction Worker");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M258.7,268.47l.11,5.41a14.3,14.3,0,0,1-6.64.13c-3.17-.84-5.29-4.54-5.29-4.54l.31-2.11Z",
  transform: "translate(-44.73 1.78)",
  fill: "#f6c8c9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M245.36,110.07l-10,40.4-18.28,18.27a5,5,0,0,0-.43,6.57l3.37,4.4a5.63,5.63,0,0,0,8.57.43l23.2-24.74L261,122.94c.27-1.41-1-12.26-1.65-13.56-.87-1.85-2.76-3.61-4.52-5.75C252.17,100.33,246.38,105.94,245.36,110.07Z",
  transform: "translate(-44.73 1.78)",
  fill: "#4463c4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M245.36,110.07l-10,40.4-18.28,18.27a5,5,0,0,0-.43,6.57l3.37,4.4a5.63,5.63,0,0,0,8.57.43l23.2-24.74L261,122.94c.27-1.41-1-12.26-1.65-13.56-.87-1.85-2.76-3.61-4.52-5.75C252.17,100.33,246.38,105.94,245.36,110.07Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient)"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "140.25 272.63 125.76 272.63 108.83 247.46 111.56 245.62 127.5 269.34 136.43 269.34 133.02 246.84 136.26 246.34 140.25 272.63",
  fill: "#4463c4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M133,268.52a2.18,2.18,0,0,1-1.17-.34,2.2,2.2,0,0,1-.67-3l14.49-22.59a2.17,2.17,0,0,1,1.84-1h30.28l25.89-62.49a2.19,2.19,0,0,1,2-1.35H227.6a2.19,2.19,0,1,1,0,4.37H207.18l-25.89,62.49a2.18,2.18,0,0,1-2,1.35H148.73l-13.84,21.6A2.18,2.18,0,0,1,133,268.52Z",
  transform: "translate(-44.73 1.78)",
  fill: "#4463c4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M229.79,179.9a2.2,2.2,0,0,1-2.19,2.19H207.18l-25.89,62.48a1.34,1.34,0,0,1-.23.4l-.06-.4-3.25.49.13.87H157.69l14.54,21.63h8.93l-3.28-21.63h1.39a2.15,2.15,0,0,0,1.79-1L185,270.85H170.49l-16.77-24.92h-5l-13.83,21.59a2.2,2.2,0,0,1-1.84,1,2.11,2.11,0,0,1-1.18-.35,2.19,2.19,0,0,1-.67-3l14.49-22.61a2.2,2.2,0,0,1,1.84-1h30.28l25.89-62.5a2.19,2.19,0,0,1,2-1.34H227.6A2.19,2.19,0,0,1,229.79,179.9Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-2)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M211.69,172l-3.7,2.67a4,4,0,0,0-1.7,5.24c.41,1.87,1,4,2.74,4.81a6.37,6.37,0,0,0,2.79.38l4.29-.06c1.82,0,4-.26,4.83-1.88.56-1.08.28-2.42.7-3.57.73-2,3.22-2.7,4.23-4.54a3.63,3.63,0,0,0-.64-4.25,7.12,7.12,0,0,0-3.33-1.49c-1.49-.37-3.43-1.3-4.9-.9C215.2,168.9,213.18,170.92,211.69,172Z",
  transform: "translate(-44.73 1.78)",
  fill: "#f6c8c9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M181.06,245a2.15,2.15,0,0,1-1.79,1h-1.39l-.13-.87,3.25-.49Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-3)"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "169.67 206.07 152.83 245.1 80.5 245.1 49.28 206.07 169.67 206.07",
  fill: "#4463c4"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  points: "169.67 206.07 152.83 245.1 80.5 245.1 49.28 206.07 169.67 206.07",
  fill: "url(#linear-gradient-4)"
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  points: "169.67 206.07 152.83 245.1 105.47 245.1 74.24 206.07 169.67 206.07",
  fill: "#4463c4"
});

var _ref15 = /*#__PURE__*/React.createElement("polygon", {
  points: "169.67 206.07 152.83 245.1 105.47 245.1 74.24 206.07 169.67 206.07",
  fill: "url(#linear-gradient-5)"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 95.81,
  cy: 275.81,
  r: 21.26,
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 95.81,
  cy: 275.81,
  r: 21.26,
  fill: "url(#linear-gradient-6)"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 101.67,
  cy: 275.81,
  r: 21.26,
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 101.67,
  cy: 275.81,
  r: 21.26,
  fill: "url(#linear-gradient-7)"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.11,
  cy: 274.48,
  r: 10.89,
  fill: "#4463c4"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.11,
  cy: 274.48,
  r: 10.89,
  fill: "url(#linear-gradient-8)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M150.3,268.52a2.23,2.23,0,0,1-1.18-.34,2.21,2.21,0,0,1-.66-3l14.48-22.59a2.2,2.2,0,0,1,1.85-1h30.28L221,179.06a2.17,2.17,0,0,1,2-1.35h21.88a2.19,2.19,0,1,1,0,4.37H224.44l-25.89,62.49a2.19,2.19,0,0,1-2,1.35H166l-13.83,21.6A2.2,2.2,0,0,1,150.3,268.52Z",
  transform: "translate(-44.73 1.78)",
  fill: "#4463c4"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M296.07,269.23l.83,5.37a14.24,14.24,0,0,1-6.58.87c-3.27-.49-5.88-3.92-5.88-3.92l0-2.13Z",
  transform: "translate(-44.73 1.78)",
  fill: "#f6c8c9"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M258.88,175.22l-12.94,43.7-.32,49.6s10.88,3.15,14.49,1.06l4.42-49.07L291,178S269.18,167.75,258.88,175.22Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M258.88,175.22l-12.94,43.7-.32,49.6s10.88,3.15,14.49,1.06l4.42-49.07L291,178S269.18,167.75,258.88,175.22Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-9)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M265.68,174.53l4.11,39.18,12.92,57.44s11.29,1.49,14.48-1.1L290.4,221l1.32-46.27S274.52,165.63,265.68,174.53Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M242.37,94c3.51,5.05,5.6.49,6.72,2.55a27.73,27.73,0,0,1,2.88,10.3s11.26-5.46,13.87-9.57c0,0-4.59-6.72-4.33-11.11s1.69-11.72-2.72-16.38S247.35,61,239.43,63.42C230.05,66.24,227.57,72.71,242.37,94Z",
  transform: "translate(-44.73 1.78)",
  fill: "#f6c8c9"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M249.48,78.05c.17,1.41.25,2.94,1.14,4,.51-.9.32-2.24.87-3,.22-.33.75-.52,1-.84a3.13,3.13,0,0,0,.72-1.25c.11-.36.17-.73.31-1.08a1.23,1.23,0,0,1,.77-.77,1.09,1.09,0,0,1,1,.38,2.46,2.46,0,0,1,.49,1,4,4,0,0,1-.14,3,3.54,3.54,0,0,1-.93,1,5.57,5.57,0,0,0-.91,1.12,3,3,0,0,1,2.35,1.63c.51.85.79,1.83,1.28,2.69a1.53,1.53,0,0,0,1.06.87c.72.05,1.17-.78,1.29-1.49s.15-1.54.72-2A3.57,3.57,0,0,0,262.15,86c1-1.24.81-3,.54-4.6q-1.08-6.13-2.68-12.16a6.23,6.23,0,0,0-1.66-3.29,5.09,5.09,0,0,0-2.25-1c-2.86-.65-7.87-.26-8.84,3.22C246.43,71.13,249.1,75.09,249.48,78.05Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M247.58,119.25a20.53,20.53,0,0,1,7.63-19.57c3.65-2.83,7.31-5.46,8.92-5.91,3.71-1,11.23,4,12.35,6.41s16.38,76.94,16.38,76.94-6.46,6.26-18.67,6.88c-16.56.84-17.88-2.31-17.88-2.31Z",
  transform: "translate(-44.73 1.78)",
  fill: "#4463c4"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M247.58,119.25a20.53,20.53,0,0,1,7.63-19.57c3.65-2.83,7.31-5.46,8.92-5.91,3.71-1,11.23,4,12.35,6.41s16.38,76.94,16.38,76.94-6.46,6.26-18.67,6.88c-16.56.84-17.88-2.31-17.88-2.31Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-10)"
});

var _ref31 = /*#__PURE__*/React.createElement("polygon", {
  points: "211.17 186.24 203.36 143.61 203.98 129.13 213.53 124.51 229.86 154.09 238.8 158.1 240.65 142.69 248.13 178.9 245.58 197.54 211.17 186.24",
  fill: "#3f3d56"
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  points: "211.17 186.24 203.36 143.61 203.98 129.13 213.53 124.51 229.86 154.09 238.8 158.1 240.65 142.69 248.13 178.9 245.58 197.54 211.17 186.24",
  fill: "url(#linear-gradient-11)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M250.32,81.22s-.92-.56-1,1.69-7.53,7.13-8.68,7.36-1.37.9-.23,2.78,3.75,4.82,5.85,4.41a21.74,21.74,0,0,0,5-1.63c3.23-2,3.88-4.6,4-8.56C255.36,84.24,252.78,80.33,250.32,81.22Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M241.64,92A25.77,25.77,0,0,0,248,88.41c2.59-2.19,2.95-1.77,3.8-.32a3.89,3.89,0,0,1-1.66,5.17c-2.16,1.19-5.48,2.54-5.95,1.93S241.76,92.64,241.64,92Z",
  transform: "translate(-44.73 1.78)",
  fill: "#f6c8c9"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M263,105.55,253,146l-18.27,18.27a5,5,0,0,0-.43,6.57l3.37,4.4a5.62,5.62,0,0,0,8.57.43l23.2-24.74,9.24-32.46c.28-1.41-1-12.26-1.64-13.56-.87-1.85-2.76-3.61-4.52-5.75C269.84,95.81,264.05,101.42,263,105.55Z",
  transform: "translate(-44.73 1.78)",
  fill: "#4463c4"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M263,105.55,253,146l-18.27,18.27a5,5,0,0,0-.43,6.57l3.37,4.4a5.62,5.62,0,0,0,8.57.43l23.2-24.74,9.24-32.46c.28-1.41-1-12.26-1.64-13.56-.87-1.85-2.76-3.61-4.52-5.75C269.84,95.81,264.05,101.42,263,105.55Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-12)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M229.87,174.16l-3.7,2.67a3.94,3.94,0,0,0-1.7,5.23c.41,1.87,1,4,2.74,4.81a6.23,6.23,0,0,0,2.79.39l4.29-.06c1.82,0,4-.26,4.83-1.88.56-1.08.28-2.43.7-3.57.73-2,3.22-2.71,4.23-4.54a3.64,3.64,0,0,0-.64-4.26,7.21,7.21,0,0,0-3.33-1.48c-1.49-.37-3.43-1.31-4.9-.9C233.39,171.06,231.36,173.08,229.87,174.16Z",
  transform: "translate(-44.73 1.78)",
  fill: "#f6c8c9"
});

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  points: "157.2 272.63 142.7 272.63 125.78 247.46 128.51 245.62 144.45 269.34 153.38 269.34 149.97 246.84 153.21 246.34 157.2 272.63",
  fill: "#4463c4"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M258.68,271.89a1.42,1.42,0,0,0-.39-.57,1.1,1.1,0,0,0-.64-.17c-1.49,0-2.79,1.09-4.28,1.19a7.84,7.84,0,0,1-3.69-1.19c-1.18-.57-2.61-1-3.76-.37a7.4,7.4,0,0,0-1.21,1,13.71,13.71,0,0,1-2.5,1.43,25.71,25.71,0,0,0-6.89,5.09,3.2,3.2,0,0,0-.65.86,2.2,2.2,0,0,0,.59,2.33c1.17,1.19,3,1.28,4.68,1.27,4.17,0,8.34-.18,12.51-.33a21.4,21.4,0,0,0,7.09-1.07,2,2,0,0,0,.93-.6,2,2,0,0,0,.31-.9c.23-1.35.48-3.15-.18-4.42S259.26,273.12,258.68,271.89Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M297.64,274.33a1.42,1.42,0,0,0-.39-.57,1.14,1.14,0,0,0-.63-.16c-1.47,0-2.76,1.07-4.23,1.17a7.71,7.71,0,0,1-3.65-1.18c-1.17-.56-2.58-1-3.71-.36a7.83,7.83,0,0,0-1.2.95,12.83,12.83,0,0,1-2.47,1.41,25.7,25.7,0,0,0-6.81,5,3.07,3.07,0,0,0-.64.85,2.18,2.18,0,0,0,.58,2.31c1.15,1.17,3,1.26,4.63,1.25,4.12,0,8.24-.17,12.36-.32a21.18,21.18,0,0,0,7-1.06,2,2,0,0,0,.92-.6,2.2,2.2,0,0,0,.31-.88c.22-1.34.47-3.12-.18-4.37S298.21,275.55,297.64,274.33Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M245,72.22l10.73,13.23s-2.08,10.37-5.78,10.88l.21,2.16s7.91-6.68,8.52-12.84l.31-4,1.13-15.41-3.39,1.54-.23,14.58-8.94-11.78Z",
  transform: "translate(-44.73 1.78)",
  fill: "#4463c4"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M245,72.22l10.73,13.23s-2.08,10.37-5.78,10.88l.21,2.16s7.91-6.68,8.52-12.84l.31-4,1.13-15.41-3.39,1.54-.23,14.58-8.94-11.78Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-13)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M226.93,78.36,228.37,75s0-.46,0-1.25c.07-3.75,1.15-15,10.89-19.6,14.56-6.84,20.06,6.29,20.32,7v0L262,62.29l.41,3.67Z",
  transform: "translate(-44.73 1.78)",
  fill: "#4463c4"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M259.59,61.1s-16.94,8.42-25.95,11.8a27.42,27.42,0,0,1-4.11,1.29l-1.16-.47c.07-3.75,1.15-15,10.89-19.6,4.32-2,7.84-2.3,10.67-1.66,6.7,1.52,9.46,8.16,9.65,8.62Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-14)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M259.59,61.1s-16.94,8.42-25.95,11.8c.24-4.41,1.82-14.43,10.86-18.68a20.91,20.91,0,0,1,5.43-1.76c6.7,1.52,9.46,8.16,9.65,8.62Z",
  transform: "translate(-44.73 1.78)",
  fill: "url(#linear-gradient-15)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M262.05,95.78c-4.36,4.22-9.55,12.71-7.49,28.49l1.31,2.31,2.39-3.85s-1.85-16.54,6.06-23.21c0,0,4.62-4.42,8.63-3l-1.59-1.25A7.11,7.11,0,0,0,262.05,95.78Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M250.76,101.16s-2.82,2.78-3.28,5.55,1.23,20.64,1.23,20.64l3.7-.77s-2.78-17.41-2.31-20.64,1.46-3,1.46-3Z",
  transform: "translate(-44.73 1.78)",
  fill: "#3f3d56"
});

var SvgUnderConstruction = function SvgUnderConstruction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 328.48 348.1",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M372,237.82c-.66,5-1.55,10-2.64,15-5.21,23.62-15.68,47.21-34.85,62-18.64,14.32-42.89,18.53-66.1,22.29-37.7,6.12-76,12.25-113.91,7.67C119,340.44,82.9,325.2,62.75,295.66c-11.62-17-16.89-37.14-17.85-57.84a182.63,182.63,0,0,1,4.26-46.76c7.62-35.35,22.78-68.62,32.24-103.51,4.6-16.93,8-34.63,17.62-49.3,10.52-16,27.7-26.94,46-32.59,33.45-10.31,87-11,119.62,4.95C312,33.77,324.7,73.32,342,119.31c10.08,26.9,25.23,52.26,29.78,80.62A131.79,131.79,0,0,1,372,237.82Z",
    transform: "translate(-44.73 1.78)",
    fill: "#4463c4",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,237.82c-.66,5-1.55,10-2.64,15-5.21,23.62-15.68,47.21-34.85,62-18.64,14.32-42.89,18.53-66.1,22.29-37.7,6.12-76,12.25-113.91,7.67C119,340.44,82.9,325.2,62.75,295.66c-11.62-17-16.89-37.14-17.85-57.84Z",
    transform: "translate(-44.73 1.78)",
    fill: "#4463c4",
    opacity: 0.36,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.13,
    cy: 288.51,
    rx: 131.37,
    ry: 13.08,
    fill: "#4463c4",
    opacity: 0.66,
    style: {
      isolation: "isolate"
    }
  }), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnderConstruction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/under_construction.9463159e.svg";
export { ForwardRef as ReactComponent };